/* script */
































































import Vue, { PropType } from 'vue'
import { groupBy, sortBy, uniq, uniqueId } from 'lodash-es'
import prefectures from '../lib/prefectures'
import { Prefecture } from '../types/index'

const __vue_script__ = Vue.extend({
  model: {
    prop: 'selected',
    event: 'input',
  },
  props: {
    selected: {
      type: Array as PropType<number[]>,
      default: (): number[] => [],
    },
    name: {
      type: String,
      default: 'prefecture_ids[]',
    },
  },
  data() {
    return {
      newSelected: this.selected.map((selected) => Number(selected)),
      checkVisible: false,
    }
  },
  computed: {
    prefecturesGroupByAreas(): Record<string, Prefecture[]> {
      return groupBy(sortBy(prefectures, 'sortKey'), 'area')
    },
    collapseId(): string {
      return uniqueId('prefecture-selection')
    },
  },
  methods: {
    onAreaClick(event: any, area: string): void {
      event.preventDefault()

      const selectedAreaPrefectureIds = this.selectedAreaPrefectureIds(area)
      if (this.isAreaPrefectureAllSelected(area)) {
        this.newSelected = this.newSelected.filter(
          (selectedId: number) => !selectedAreaPrefectureIds.includes(selectedId),
        )
      } else {
        this.newSelected = uniq([
          ...this.newSelected,
          ...Object.values(this.prefecturesGroupByAreas[area]).map(
            (prefecture: Prefecture) => prefecture.id,
          ),
        ])
      }
    },
    isAreaPrefectureAllSelected(area: string): boolean {
      return this.selectedAreaPrefectureIds(area).every((prefectureId: number) =>
        this.newSelected.some((selectedId: number) => selectedId === prefectureId),
      )
    },
    selectedAreaPrefectureIds(area: string): number[] {
      return Object.values(this.prefecturesGroupByAreas[area]).map(
        (prefecture: Prefecture) => prefecture.id,
      )
    },
    onInput(): void {
      this.$emit('input', this.newSelected)
    },
    prefectureName(prefectureId: number): string {
      return prefectures[prefectureId].name
    },
    toggle(event: any): void {
      event.preventDefault()
      this.checkVisible = !this.checkVisible
    },
    deselect(deselectedId: number): void {
      this.newSelected = this.newSelected.filter(
        (prefectureId: number) => prefectureId !== deselectedId,
      )
    },
    clear(): void {
      this.newSelected = []
    },
    selectAllDomestic(): void {
      const domesticPrefectureIds = Object.values(prefectures)
        .filter((prefecture) => prefecture.area !== '海外')
        .map((prefecture) => prefecture.id)
      this.newSelected = uniq(domesticPrefectureIds.concat(this.newSelected))
    },
  },
})

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          attrs: { size: "sm", variant: "outline-secondary mb-1" },
          on: { click: _vm.toggle },
        },
        [_vm._v("地域を選択する")]
      ),
      _vm._v(" "),
      _c(
        "b-collapse",
        {
          staticClass: "mt-2 mb-2",
          model: {
            value: _vm.checkVisible,
            callback: function ($$v) {
              _vm.checkVisible = $$v
            },
            expression: "checkVisible",
          },
        },
        [
          _c(
            "b-form-checkbox-group",
            {
              attrs: { name: _vm.name },
              on: { input: _vm.onInput },
              model: {
                value: _vm.newSelected,
                callback: function ($$v) {
                  _vm.newSelected = $$v
                },
                expression: "newSelected",
              },
            },
            _vm._l(_vm.prefecturesGroupByAreas, function (prefectures, area) {
              return _c(
                "b-row",
                { key: area, staticClass: "border-bottom" },
                [
                  _c(
                    "b-col",
                    { attrs: { sm: "2" } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-primary px-sm-2 px-0 text-nowrap",
                          attrs: { variant: "link", size: "sm" },
                          on: {
                            click: function (e) {
                              return _vm.onAreaClick(e, area)
                            },
                          },
                        },
                        [
                          _vm.isAreaPrefectureAllSelected(area)
                            ? _c("i", { staticClass: "fal fa-check-square" })
                            : _c("i", { staticClass: "fal fa-square" }),
                          _vm._v(
                            "\n            " + _vm._s(area) + "\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { sm: "10" } },
                    _vm._l(prefectures, function (prefecture) {
                      return _c(
                        "b-form-checkbox",
                        { key: prefecture.id, attrs: { value: prefecture.id } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(prefecture.name) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-2" },
            [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary", size: "sm" },
                  on: { click: _vm.selectAllDomestic },
                },
                [_vm._v("\n        国内を全て選択\n      ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary", size: "sm" },
                  on: { click: _vm.clear },
                },
                [_vm._v("\n        全て解除\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.newSelected.length == 0
        ? _c(
            "b-alert",
            { staticClass: "mb-1", attrs: { show: "", variant: "warning" } },
            [
              _c(
                "b-btn",
                {
                  staticClass: "text-secondary p-0",
                  attrs: { variant: "link", size: "sm" },
                  on: { click: _vm.toggle },
                },
                [_vm._v("\n      地域は未選択です\n    ")]
              ),
            ],
            1
          )
        : _c(
            "b-alert",
            { staticClass: "mb-1", attrs: { show: "", variant: "warning" } },
            [
              _c("div", { staticClass: "text-muted" }, [_vm._v("選択済み")]),
              _vm._v(" "),
              _vm._l(_vm.newSelected, function (prefectureId) {
                return _c(
                  "b-button",
                  {
                    key: prefectureId,
                    staticClass: "mr-1 my-1",
                    attrs: { size: "sm" },
                    on: {
                      click: function ($event) {
                        return _vm.deselect(prefectureId)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fal fa-times" }),
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.prefectureName(prefectureId)) +
                        "\n    "
                    ),
                  ]
                )
              }),
            ],
            2
          ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "app/javascript/src/components/PrefectureSelection.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__